require("fslightbox")
document.addEventListener('DOMContentLoaded', function () {
	initLotSlider(document.querySelectorAll('.lot-slider'))
	initCalendarSlider(document.querySelectorAll('.calendar-slider'))
	initCalendar(document.querySelector('.calendar'))
})

function initCalendar(calendar) {
	if (calendar) {
		calendar.querySelectorAll('.block')
			.forEach(function (block) {
				block.style["grid-column"] = `${+block.dataset.start + 1} / span ${block.dataset.length ? block.dataset.length : 1}`
			})
		calendar.querySelector('.names-toggler')
			.addEventListener('click', function () {
				calendar.classList.toggle("hide-names");
			})
	}
}

function arrowsValign(slider, alignTarget) {
	if (slider.$nextArrow && slider.$nextArrow.is(':visible')) {
		var $prev = slider.$prevArrow,
			$next = slider.$nextArrow,
			targetH = $(alignTarget)
			.outerHeight(),
			arrowH = $prev.outerHeight();
		var offset = targetH / 2 - arrowH / 2;
		css = {
			top: offset + 'px'
		};
		$prev.css(css);
		$next.css(css);
	} else {
		return false;
	}
}
var slickButtons = {
	prev: '<button class="slick-arrow slick-prev"><span class="k-icon icon-arrow-left"></span></button>',
	next: '<button class="slick-arrow slick-next"><span class="k-icon icon-arrow-right"></span></button>'
};

function initLotSlider(sliders) {
	if (sliders.length) {
		var $lotSlider = $(sliders);
		$lotSlider.each(function () {
			var $this = $(this);
			if ($this.is('.product-slider')) {
				$this.on('init', function (ev, slider) {
					var photo = slider.$slides[0].querySelector('.product-card__pic');
					arrowsValign(slider, photo);
				});
			}
			$this.slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				prevArrow: slickButtons.prev,
				nextArrow: slickButtons.next,
				responsive: [{
					breakpoint: 992,
					settings: "unslick"
				}, {
					breakpoint: 1340,
					settings: {
						arrows: false
					}
				}]
			});
		});
	}
}

function initCalendarSlider(sliders) {
	if (sliders.length) {
		var $lotSlider = $(sliders);
		$lotSlider.each(function () {
			var $this = $(this);
			if ($this.is('.product-slider')) {
				$this.on('init', function (ev, slider) {
					var photo = slider.$slides[0].querySelector('.product-card__pic');
					arrowsValign(slider, photo);
				});
			}
			$this.slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				prevArrow: slickButtons.prev,
				nextArrow: slickButtons.next,
				responsive: [{
					breakpoint: 1340,
					settings: {
						arrows: false
					}
				}, {
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: true
					}
				}]
			});
		});
	}
}